var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 140 140",
    style: {
      enableBackground: "new 0 0 140 140"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{fill:#FFC800;}\r\n\t.st3{fill:#AA5528;}\r\n\t.st4{fill:none;stroke:#F6D3AB;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st6{fill:#DBA700;}\r\n\t.st7{fill:#1CB0F6;}\r\n\t.st8{fill:#53CFF9;}\r\n\t.st9{fill:#76E2FC;}\r\n\t.st10{fill:none;stroke:#E3FEFC;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st11{fill:none;stroke:#FFFFFF;stroke-width:3.8857;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st12{fill:#FF9600;}\r\n\t.st13{fill:#FFB83F;}\r\n\t.st14{fill:#FFCC66;}\r\n\t.st15{fill:none;stroke:#FFF2CC;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st16{fill:#777777;}\r\n\t.st17{fill:#ADADAD;}\r\n\t.st18{fill:#D6D6D6;}\r\n\t.st19{fill:none;stroke:#F8F8F8;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st20{fill:#7A2A14;}\r\n\t.st21{fill:#BF2138;}\r\n\t.st22{fill:#DF2E38;}\r\n\t.st23{fill:none;stroke:#FFE199;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st24{fill:#DB7700;}\r\n\t.st25{fill:none;stroke:#E6E6E6;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st26{fill:#B16A33;}\r\n\t.st27{fill:#CE8946;}\r\n\t.st28{fill:none;stroke:#F0C991;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st29{fill:#944F23;}\r\n\t.st30{fill:#FFD899;}\r\n\t.st31{fill:#F4F4F4;}\r\n\t.st32{fill:none;stroke:#FBBCAB;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st33{fill:#F2F2F2;}\r\n\t.st34{fill:#FF9388;}\r\n\t.st35{fill:#FFFFFF;}\r\n\t.st36{fill:#FFCC73;}\r\n\t.st37{fill:#CECECE;}\r\n\t.st38{fill:#FBBCAB;}\r\n\t.st39{fill:none;stroke:#FFEF99;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st40{fill:#F5A800;}\r\n\t.st41{fill:#CC7E00;}\r\n\t.st42{fill:#B27700;}\r\n\t.st43{fill:#75DB33;}\r\n\t.st44{fill:none;stroke:#BAFBFE;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st45{fill:#BAFBFE;}\r\n\t.st46{fill:#7CDDF7;}\r\n\t.st47{fill:#62CBF4;}\r\n\t.st48{fill:#297DB3;}\r\n\t.st49{fill:#5894AF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grid",
    className: "st0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "background"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "chest"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "blue_gem"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M36.448,50.632v38.735l-21.865,12.629c-1.084-1.932-1.696-4.1-1.696-6.362v-51.27 c0-2.262,0.613-4.43,1.696-6.362L36.448,50.632z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M70,108.783v25.211c-2.215,0-4.43-0.565-6.362-1.697l-44.391-25.635c-1.979-1.131-3.581-2.733-4.665-4.665 l21.865-12.629L70,108.783z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M125.417,101.997c-1.084,1.932-2.686,3.534-4.665,4.665l-44.391,25.635c-1.932,1.131-4.147,1.697-6.362,1.697 v-25.211l33.552-19.415L125.417,101.997z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M127.114,44.365v51.27c0,2.262-0.613,4.43-1.696,6.362l-21.865-12.629V50.632l21.865-12.629 C126.501,39.935,127.114,42.103,127.114,44.365z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M125.417,38.003l-21.865,12.629L70,31.217V6.006c2.215,0,4.43,0.565,6.362,1.697l44.391,25.635 C122.731,34.469,124.334,36.071,125.417,38.003z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M70,6.006v25.211L36.448,50.632L14.583,38.003c1.084-1.932,2.686-3.534,4.665-4.665L63.638,7.703 C65.57,6.572,67.785,6.006,70,6.006z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "103.552,50.632 103.552,89.368 70,108.783 36.448,89.368 36.448,50.632 70,31.217  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 59.042,
    y1: 45.725,
    x2: 70,
    y2: 39.384
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 50.562,
    y1: 50.632,
    x2: 51.492,
    y2: 50.094
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M12.866,44.377v51.247c0,4.556,2.431,8.766,6.377,11.045l44.381,25.623c3.946,2.278,8.807,2.278,12.753,0 l44.381-25.623c3.946-2.278,6.377-6.488,6.377-11.045V44.377c0-4.556-2.431-8.766-6.377-11.045L76.377,7.709 c-3.946-2.278-8.807-2.278-12.753,0L19.242,33.332C15.297,35.61,12.866,39.82,12.866,44.377z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M12.866,44.377v51.247c0,4.556,2.431,8.766,6.377,11.045l44.381,25.623c3.946,2.278,8.807,2.278,12.753,0 l44.381-25.623c3.946-2.278,6.377-6.488,6.377-11.045V44.377c0-4.556-2.431-8.766-6.377-11.045L76.377,7.709 c-3.946-2.278-8.807-2.278-12.753,0L19.242,33.332C15.297,35.61,12.866,39.82,12.866,44.377z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "orange_gem"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "gem_faded"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "blue_gem_chest"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "orange_gem_chest"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "gold_medal"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "silver_medal"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "bronze_medal"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "shining_streak_calendar_7"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "shining_streak_calendar_14"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "shining_streak_calendar_30"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "calendar_7"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "calendar_14"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "calendar_30"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "combined_calendars"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "banana"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "unlimited_heart"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.e93cfa02cc011266f1b1ae2f20d517ae.svg";
export { ForwardRef as ReactComponent };